import { render, staticRenderFns } from "./coa.vue?vue&type=template&id=d179b6dc&"
import script from "./coa.vue?vue&type=script&lang=js&"
export * from "./coa.vue?vue&type=script&lang=js&"
import style0 from "./coa.vue?vue&type=style&index=0&id=d179b6dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VTextField,VToolbar})
